import { useState, useEffect } from 'react';

export function useIsKeyHeld(key: string): boolean {
  const [isHeld, setIsHeld] = useState(false);

  useEffect(() => {
    // Skip this feature in production builds
    if (process.env.NODE_ENV === 'production') {
      return;
    }
    // Since 2021 you can supply an AbortSignal which can be used to remove
    // every event listener registered using that signal. Even for a single
    // event listener, it's still useful since you no longer have to retain a
    // reference to the callback function.
    const abortController = new AbortController();
    const { signal } = abortController;
    window.addEventListener(
      'keydown',
      (event) => {
        if (event.key === key) {
          setIsHeld(true);
        }
      },
      { signal }
    );
    window.addEventListener(
      'keyup',
      (event) => {
        if (event.key === key) {
          setIsHeld(false);
        }
      },
      { signal }
    );
    // Pretend the key is let go when the page loses focus. We can't track key
    // events outside of the page, and we don't want the key to get "stuck"
    // down.
    window.addEventListener(
      'blur',
      () => {
        setIsHeld(false);
      },
      { signal }
    );
    return () => {
      abortController.abort();
    };
  }, [key]);

  return isHeld;
}
